<template>
	<section class="app-user user-watches">
		<div class="header">
			<h1>{{ $t('base.general.support') }}</h1>

			<div class="btn-group">
				<button-native-icon-text
					icon="plus-w"
					class="plus btn-add"
					@click.native="onModalBoxOpen()">
					{{ $t('base.general.new_ticket') }}
				</button-native-icon-text>
			</div>

		</div>
		<div class="body">
			<div v-if="tickects.length > 0">
				<div class="support-table">

					<div class="support-table__header">
						<div class="header__column">#ID</div>
						<div class="header__column">{{ $t('labels.general.subject') }}</div>
						<div class="header__column">{{ $t('labels.general.state') }}</div>
						<div class="header__column">{{ $t('labels.general.last_activity') }}</div>
						<div class="header__column"></div>
					</div>

					<div class="support-table__item" v-for="tickect in tickects" :key="tickect.id">
						<div class="support-table__column">{{ tickect.id }}</div>
						<div class="support-table__column">{{ tickect.subject }}</div>
						<div class="support-table__column">{{ tickect.state }}</div>
						<div class="support-table__column">{{ tickect.last }}</div>
						<div class="support-table__column"><router-link class="nav-link btn" :to="{ name: 'Ticket', params: { user_uid: user_uid, ticket_id: tickect.id } }">{{ $t('labels.general.see') }}</router-link></div>
					</div>

				</div>
			</div>
			<div v-else>
				<h1>No tickets to display</h1>
			</div>
		</div>

		<modal-box v-if="modalBox.open" @close="onModalBoxClose" :header="$t('base.general.new_ticket')" :subHeader="$t('base.general.support')">
			<new-tickect-form-component @completed="onFormCompleted"></new-tickect-form-component>
		</modal-box>

	</section>
</template>

<script>
	import NewTickectFormComponent from './forms/NewTickectFormComponent'
	export default {
		name: 'support-component',
		components: {
			NewTickectFormComponent
		},
		props: [
			'user_uid'
		],
		data () {
			return {
				modalBox: {
					open: false,
				},
				tickects: [
					{ id: 1, subject: 'O relógio não conecta', state: this.$t('labels.general.open'), last: '2020-01-20 14:54' },
					{ id: 2, subject: 'Não consigo aceder à minha área pessoal', state: this.$t('labels.general.open'), last: '2020-01-20 14:54' },
					{ id: 3, subject: 'Valores de temperatura muito dispares', state: this.$t('labels.general.open'), last: '2020-01-20 14:54' },
					{ id: 4, subject: 'Não consigo mudar de língua', state: this.$t('labels.general.open'), last: '2020-01-20 14:54' },
					{ id: 5, subject: 'Não consigo adicionar um paciente ao relógio', state: this.$t('labels.general.open'), last: '2020-01-20 14:54' },
					{ id: 6, subject: 'Não estou a receber alertas', state: this.$t('labels.general.closed'), last: '2020-01-20 14:54' },
					{ id: 7, subject: 'Como acedo aos documentos médicos', state: this.$t('labels.general.closed'), last: '2020-01-20 14:54' },
					{ id: 8, subject: 'Erro ao mudar de conta', state: this.$t('labels.general.closed'), last: '2020-01-20 14:54' },
				]
			}
		},
		methods: {
			onModalBoxClose() {
				this.modalBox.open = false
			},
			onModalBoxOpen() {
				this.modalBox.open = true
			},
			onFormCompleted() {
				this.modalBox.open = false
			}
		}
	}
</script>

<style scope>
	.header:not(.large) {
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px solid var(--main-color);
		min-height: 44px;
	}
	.app-watch > .header {
		display: block;
		border-bottom: 0;
		min-height: unset;
	}
	.header h1{
		border-bottom: 0;
	}
	.support-table {
		width: 100%;
		font-size: 16px;
		border-radius: var(--border-radius) var(--border-radius) 0 0;
		box-shadow: 0px 0px 5px 0px rgba(170,170,170,0.5);
	}
	.support-table__item {
		grid-template-columns: 0.5fr 3fr 0.5fr 1fr 0.5fr;
		display: grid;
	}
	.support-table__header {
		grid-template-columns: 0.5fr 3fr 0.5fr 1fr 0.5fr;
		display: grid;
	}
	.support-table__item:nth-child(odd) {
		background: white;
	}
	.support-table__item:nth-child(even) {
		background: #fafafa;
	}
	.support-table__column {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
		text-align: left;
		font-family: var(--font-bold);
		color: #888;
		padding: 10px;
	}
	.header__column {
		font-size: .7em;
		font-weight: 700;
		padding-top: 20px;
		padding-bottom: 20px;
		text-transform: uppercase;
		border-top: 1px solid #f3f3f3;
		border-bottom: 1px solid #f3f3f3;
		color: #888;
		font-family: var(--font-bold);
		padding: 10px;
	}
	.support-table__item {
		height: 60px;
	}
	.support-table__item:last-of-type {
		margin-bottom: 0;
	}
	.support-table__item:hover {
		background: #f3f3f3;
	}
	.support-table__item .support-table__column {
		font-size: 0.9em;
	}
	.support-table__item .support-table__column:first-of-type {
		border-left: 1px solid #f3f3f3;
		padding-left: 20px;
	}
	.support-table__item .support-table__column:last-of-type {
		border-right: 1px solid #f3f3f3;
		padding-right: 20px;
	}
	.support-table__item .support-table__column .btn {
		font-size: 12px;
		min-height: 35px;
		min-width: 70px;
		border-radius: 100px;
		text-transform: uppercase;
		margin: 0;
		background-color: #00A2AC;
		color: white;
	}
	@media screen and (max-width: 1025px) {
		.app-user > .header {
			margin-left: 20px;
			margin-right: 20px;
		}
	}
	@media screen and (max-width: 600px) {
		.support-table__item:nth-child(odd) {
			background: #fafafa;
		}
		.support-table__item:nth-child(even) {
			background: white;
		}
		.support-table__item .support-table__column {
			font-size: 0.7em;
		}
		.support-table__item .support-table__column .btn {
			font-size: 9px;
			font-weight: bold;
			min-height: 26px;
			min-width: 34px;
		}
		.support-table__header {
			font-size: 12px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/support/SupportComponent.vue